<div class="modal-header">
  <h2 class="mb-0">Attention</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>
<div class="modal-body">
  <h2 class="mb-0">You are going to set quoted time to <b>{{ defaultQuotedTime }}</b> minutes. Are you sure?</h2>
</div>
<div class="modal-footer">
  <button
    type="submit"
    class="btn btn-success"
    (click)="submit()"
  >Confirm</button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="cancel()"
  >Cancel</button>
</div>
